<template>
    <div class="msl_page">
        <!-- 导航栏 -->
        <div class="nav row_center"  :class="[ activeIndex == 0 || activeIndex == 1 || ( activeIndex == 2 && !isDetail ) || activeIndex == 3 ? 'showly' : '', showShadow ? 'white_bg' :  ''  ]"> <!-- showShadow &&  --> <!-- , showNav ? 'show_nav hover_line_showly' : 'hide_nav leave_line_showly' --> <!-- showNav ? 'show_nav hover_line_showly' : 'hide_nav leave_line_showly',  -->
            <div class="tab_box">
                <div class="center m_center space_center">
                    <div class="logo pointer">
                        <router-link to="./index" class="td_none">
                            <img src="../assets/logo.png" alt="">
                        </router-link>
                    </div>
                    <div class="left_center">
                        <div class="tab_item pointer" v-for="(item, index) in tabsArr" :key="index">
                            <router-link :to="item.url" class="td_none left_center">
                                <div class="ti_child r_position" :class="{ active: activeIndex == index }">{{ item.name }}</div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="width: 100%; height: 74px;" v-if="activeIndex == 4 || ( activeIndex == 2 && isDetail )"></div>
        <!-- 主体内容 -->
        <slot name="mslBody"></slot>
        <!-- 留言咨询 -->
        <div class="msg" v-if="showMsg">
            <el-row v-loading.fullscreen.lock="fullscreenLoading">
                <div class="center m_center msg_center">
                    <div class="m_header">
                        <div class="title">留言咨询</div>
                        <div class="intro">随时告诉我们你的需要</div>
                    </div>
                    <div class="form">
                        <el-form label-position="top" ref="form" :model="formData" :rules="rules" label-width="80px">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="姓名" prop="name">
                                        <el-input v-model="formData.name" placeholder="请输入姓名"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="联系方式" prop="mobile">
                                        <el-input v-model="formData.mobile" placeholder="请输入联系方式"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <el-form-item label="联系地址" prop="address">
                                        <el-input v-model="formData.address" placeholder="请输入联系地址"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="详细需求" prop="content">
                                        <el-input type="textarea" v-model="formData.content" placeholder="请输入详细需求"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="send_area row_center">
                        <div class="send row_center pointer hover_slowly leave_slowly" @click="sumbit">
                            发送
                        </div>
                    </div>
                </div>
            </el-row>
        </div>
        <!-- 留言入口 -->
        <div class="to_comment r_position" v-else>
            <img src="../assets/pc_pic/index/top_cir.png" alt="" class="img_box_1 a_position a_position l_0 t_0">
            <img src="../assets/pc_pic/index/bottom_cir.png" alt="" class="img_box_2 a_position a_position b_0 r_0">
            <div class="center m_center to_comment_center">
                <div class="txt ta_center">如有需要，留言咨询</div>
                <div class="intro ta_center">我们将会为你提供更优质的服务，为你呈现更出色的产品</div>
                <div class="btn_area row_center">
                    <router-link to="./contact" class="td_none">
                        <div class="btn row_center leave_slowly pointer">
                            留言咨询
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div class="footer">
            <div class="center m_center footer_center flex flex-dir-left flex-main-justify r_position">
                <div class="c_left flex flex-dir-left">
                    <div class="f_item">
                        <div class="f_title">我们公司</div>
                        <div class="f_line"></div>
                        <div class="f_intro">德国曼稣勒（中国）权利中心</div>
                      <div class="f_intro">曼稣勒环境科技（上海）有限公司</div>
                        <div class="f_intro">地址：中国（上海）自由贸易试验区富特西一路139号1号楼第一层101室</div>
                        <div class="f_intro">联系电话：400-047-5178</div>
                        <div class="f_intro mb_0">邮政编码：200131</div>
                    </div>
					
					                
                    <div class="f_item ml_60">
                        <div class="f_title">备案信息</div>
                        <div class="f_line"></div>
                        <div class="f_intro"><a style="color: #8c8c8c;" href="https://beian.miit.gov.cn/" target="_blank">渝ICP备09061955号-4</a></div>
                    </div>
					
				</div>
                <div class="c_right" style="margin-right: 24px;">
					<div class="f_item ml_60 h_code">
					    <div class="f_title">关注我们</div>
					    <div class="f_line"></div>
						<div class="f_intro_4 flex flex-dir-top flex-main-left flex-cross-top pointer">
							<a href="https://crm.mansul.com/" class="a_view">曼稣勒CRM管理系统</a>
							<!-- <span>曼稣勒CRM管理系统</span> -->
							<!-- <span class="code_3">
								<img src="../assets/pc_pic/code_cir_mjh.png" alt="" class="img">
							</span> -->
						</div>
					    <div class="f_intro_1 flex flex-dir-top flex-main-left flex-cross-top pointer" v-for="(item, index) in codeArr" @mouseenter="showCode(item)" @mouseleave="showCode(item)">
							<!-- <a href="">官方公众号</a> -->
					    	<span>{{ item.name }}</span>
					    	<span class="code_1" v-if="item.show">
					    		<img src="../assets/pc_pic/code_circle.png" alt="" class="img" v-if="item === codeArr[0]">
					    		<img src="../assets/pc_pic/code_cir_mjh.png" alt="" class="img" v-if="item === codeArr[1]">
					    		<img src="../assets/pc_pic/CRM.png" alt="" class="img" v-if="item === codeArr[2]">
					    		<img src="../assets/pc_pic/code_zheng.png" alt="" class="img" v-if="item === codeArr[3]">
					    	</span>
					    </div>
					    <!-- <div class="f_intro_2 flex flex-dir-top flex-main-left flex-cross-top pointer">
					    	<span>曼家</span>
					    	<span class="code_2">
					    		<img src="../assets/pc_pic/code_circle.png" alt="" class="img">
					    	</span>
					    </div>
					    <div class="f_intro_3 flex flex-dir-top flex-main-left flex-cross-top pointer">
					    	<span>曼家汇</span>
					    	<span class="code_3">
					    		<img src="../assets/pc_pic/code_cir_mjh.png" alt="" class="img pointer">
					    	</span>
					    </div>
						<div class="f_intro_5 flex flex-dir-top flex-main-left flex-cross-top pointer">
							<span>曼稣勒CRM</span>
							<span class="code_3">
								<img src="../assets/pc_pic/code_cir_mjh.png" alt="" class="img">
							</span>
						</div> -->
					    
					    
					</div>
					<!-- <div class="line1 flex flex-dir-left flex-cross-center flex-main-center">
						<div class="f_item column_center">
						    <div class="f_img">
						        <img src="../assets/pc_pic/code_zheng.png" alt="" class="img">
						    </div>
						    <div class="f_intro">曼稣勒官方公众号</div>
						</div>
						<div class="f_item ml_36 column_center">
						    <div class="f_img">
						        <img src="../assets/pc_pic/code_circle.png" alt="" class="img">
						    </div>
						    <div class="f_intro">曼家</div>
						</div>
						<div class="f_item ml_36 column_center">
						  <div class="f_img">
						    <img src="../assets/pc_pic/code_cir_mjh.png" alt="" class="img">
						  </div>
						  <div class="f_intro">曼家汇</div>
						</div>
					</div>
					<div class="line2 flex flex-dir-left flex-cross-center flex-main-center" style="margin-top: 12px;">
						<div class="f_item ml_36 column_center">
						    <div class="f_img">
						        <img src="../assets/pc_pic/code_circle.png" alt="" class="img">
						    </div>
						    <div class="f_intro">曼家</div>
						</div>
						<div class="f_item ml_36 column_center">
						  <div class="f_img">
						    <img src="../assets/pc_pic/code_cir_mjh.png" alt="" class="img">
						  </div>
						  <div class="f_intro">曼家汇</div>
						</div>
					</div> -->
                    
                    <div class="back_top row_center a_position pointer" @click="backTop" v-if="showTop">
                        <span class="iconfont iconicon-05 icon"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { msgConsult } from '../api/common.js'
    export default {
        name: "contact",

        data() {
            return {
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' }
                    ]
                },
                fullscreenLoading: false,
                showNav: true,
                showShadow: false,
                scroll: '', // 滚动高度
                scrollTop: 0,
                formData: {
                    name: '',
                    mobile: '',
                    address: '',
                    content: ''
                },
                activeIndex: 0,
                tabsArr: [
                    {
                        name: '首页',
                        url: './index'
                    },
                    {
                        name: '产品分类',
                        url: './production'
                    },
                    {
                        name: '相关资讯',
                        url: './news'
                    },
                    {
                        name: '公司信息',
                        url: './company_info'
                    },
                    {
                        name: '联系我们',
                        url: './contact'
                    },
                    {
                      name: '英文官网',
                      url: './en'
                    },
                ],
                showTop: false,
				codeArr: [
					
					{
						name: '曼家',
						url: '../assets/pc_pic/code_circle.png',
						show: false
					},
					{
						name: '曼家汇',
						url: '../assets/pc_pic/code_cir_mjh.png',
						show: false
					},
					{
						name: '曼稣勒CRM',
						url: '../assets/pc_pic/CRM.png', 
						show: false
					},
					{
						name: '曼稣勒官方公众号',
						url: '../assets/pc_pic/code_zheng.png',
						show: true
					}
				]
            }
        },
        watch: {
            aIndex: {
                handler (val) {
                    this.activeIndex = val;
                },
                immediate: true
            }
        },
        mounted() {
            window.addEventListener('scroll',this.handleScroll)
            window.addEventListener('scroll',this.scrollToTop)
        },
        props: {
            showMsg: {
                type: Boolean,
                default: false
            },
            aIndex: {
                type: [Number, String],
                default: 0
            },
            isDetail: {
                type: Boolean,
                default: false
            }
        },
        methods: {
			showCode(item) {
				console.log(1);
				var codeItem = item;
				this.codeArr.forEach((ritem)=> {
					ritem.show = false;
					if (codeItem === ritem) {
						console.log(2);
						item.show = true;
					}
				})
			},
            sumbit () {
                if(!this.formData.name) {
                    this.$message.error('请输入姓名')
                    return
                }
                if(!this.formData.name) {
                    this.$message.error('请输入手机号码')
                    return
                }

                var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
                if (!myreg.test(this.formData.mobile)) {
                    this.$message.error('请输入正确格式的手机号码')
                    return
                }

                this.fullscreenLoading = true;
                try {
                    msgConsult(this.formData).then(res => {
                        if(res.code == 1) {
                            this.fullscreenLoading = false;
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            })
                            this.formData = {
                                name: '',
                                mobile: '',
                                address: '',
                                content: ''
                            }
                        }
                    })
                } catch {
                    this.$message.error('留言失败，请重试')
                }
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop||document.body.scrollTop;
                if (this.scroll > 20) {
                    this.toggerNavStatus();
                } else {
                    this.showNav = true;
                }
                this.old_scroll = this.scroll;

                this.showShadow = Number(this.scroll) > 5 ? true : false;
                this.showTop = Number(this.scroll) > 300 ? true : false;
            },
            toggerNavStatus () {
                this.showNav = this.scroll > this.old_scroll ? false : true;
            },
            // handleScroll(){
            //     this.scroll = document.documentElement.scrollTop||document.body.scrollTop;
            //     this.showShadow = Number(this.scroll) > 5 ? true : false;
            //     this.showTop = Number(this.scroll) > 300 ? true : false;
            // },
            backTop () {
                const that = this
                let timer = setInterval(() => {
                    let ispeed = Math.floor(-that.scrollTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                    if (that.scrollTop === 0) {
                        clearInterval(timer)
                    }
                }, 16)
            },
            // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
            scrollToTop () {
                const that = this
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                that.scrollTop = scrollTop
                if (that.scrollTop > 60) {
                    that.btnFlag = true
                } else {
                    that.btnFlag = false
                }
            }


        }
    }
</script>

<style scoped lang="scss">

    .show_nav {
        height: 74px;
    }
    .hide_nav {
        height: 0;
    }

    .msl_page {
        .shadow {
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);

        }
        .white_bg {
            background-color: #fff;
        }
        .showly {
            transition-duration: .6s;
            -moz-transition-duration: .6s;
            -webkit-transition-duration: .6s;
            -o-transition-duration: .6s;
        }

        .nav {
            width: 100%;
            position: fixed;
            top: 0;
            z-index: 100;

            .tab_box {
                overflow: visible!important;
                /*height: 82px;*/
                .logo {
                    width: 200px;
                    height: 48px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .tab_item {
                    padding: 0 24px;
                    box-sizing: border-box;
                    /*height: 74px;*/
                    &:last-child {
                        padding-right: 0;
                    }
                    &:hover {
                        .ti_child {
                            &::after {
                                width: 100%;
                                background-color: #262626;
                                transition: width 0.3s linear;
                                -moz-transition: width 0.3s linear; /* Firefox 4 */
                                -webkit-transition: width 0.3s linear; /* Safari å’Œ Chrome */
                                -o-transition: width 0.3s linear; /* Opera */
                            }
                        }
                    }
                    .ti_child {
                        padding: 25px 0;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 24px;
                        color: #333333;

                        &::after {
                            content: '';
                            display: inline-block;
                            width: 0;
                            height: 2px;
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            transition: width 0.3s linear;
                            -moz-transition: width 0.3s linear; /* Firefox 4 */
                            -webkit-transition: width 0.3s linear; /* Safari å’Œ Chrome */
                            -o-transition: width 0.3s linear; /* Opera */
                        }
                    }
                    &:hover {
                        .ti_child {
                            font-weight: bold!important;
                            /*border-bottom: 2px solid #333333;*/
                        }
                    }
                    .active {
                        font-weight: bold!important;
                        &::after {
                            width: 100%;
                            background-color: #262626;
                            transition: width 0.3s linear;
                            -moz-transition: width 0.3s linear; /* Firefox 4 */
                            -webkit-transition: width 0.3s linear; /* Safari å’Œ Chrome */
                            -o-transition: width 0.3s linear; /* Opera */
                        }
                    }
                }
            }
        }

        /* 留言咨询 */
        .msg {
            width: 100%;
            background-color: #262626;
            .msg_center {
                padding: 60px 0;
                .m_header {
                    .title {
                        font-size: 30px;
                        font-weight: bold;
                        line-height: 38px;
                        color: #FFFFFF;
                    }
                    .intro {
                        font-size: 16px;
                        line-height: 28px;
                        color: #FFFFFF;
                        opacity: 0.6;
                        margin-top: 12px;
                    }
                }
            }

            .form {
                margin-top: 40px;
                &::v-deep {
                    .el-form-item__label {
                        color: #fff!important;
                    }
                    input, textarea {
                        background-color: transparent;
                        color: #fff;
                        outline:none;
                    }
                    .el-input__inner, .el-textarea__inner {
                        &:focus {
                            border-color: #fff;
                        }
                    }
                    textarea {
                        height: 130px!important;
                        color: #fff;
                    }
                }
            }

            .send_area {
                .send {
                    width: 167px;
                    height: 42px;
                    background: #FFFFFF;
                    border-radius: 2px;
                    font-size: 16px;
                    font-family: Alibaba PuHuiTi;
                    font-weight: 400;
                    line-height: 22px;
                    color: #262626;
                    margin-top: 40px;
                    &:hover {
                        background-color: #d0d0d0;

                    }
                }
            }
        }

        /* 留言进口 */
        .to_comment {
            width: 100%;
            background-color: #262626;
            .img_box_1 {
                width: 150px;
                height: 150px;
            }
            .img_box_2 {
                width: 150px;
                height: 150px;
            }
            .to_comment_center {
                padding: 64px 0;
                box-sizing: border-box;
                .txt {
                    font-size: 30px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    line-height: 38px;
                    color: #FFFFFF;
                }
                .intro {
                    margin-top: 16px;
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    line-height: 24px;
                    color: #D9D9D9;
                    opacity: 0.8;
                }
                .btn_area {
                    width: 100%;
                    margin-top: 36px;
                    .btn {
                        width: 111px;
                        height: 42px;
                        background: #FFFFFF;
                        opacity: 1;
                        border-radius: 2px;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 22px;
                        color: #262626;
                        &:hover {
                            background: #ccc;
                        }
                    }

                }
            }
        }

        /* 底部信息 */
        .footer {
            width: 100%;
            background-color: #fafafa;
            .footer_center {
                padding: 80px 0;
                box-sizing: border-box;
                overflow: visible;
                .mt_29 {
                    margin-top: 29px!important;
                }
                .ml_36 {
                    margin-left: 36px;
                }
                .ml_60 {
                    margin-left: 60px;
                }
                .c_left {
                    .f_item {
                        .f_title {
                            font-size: 24px;
                            font-weight: bold;
                            line-height: 32px;
                            color: #333333;
                        }
                        .f_line {
                            width: 20px;
                            height: 1px;
                            background-color: #333;
                            margin-top: 24px;
                            margin-bottom: 24px;
                        }
                        .f_intro,
                        .f_intro_1,
                        .f_intro_4
						{
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 22px;
                            color: #8C8C8C;
                            margin-bottom: 16px;
							img {
								width: 96px;
								height: 96px;
							}
							
                        }
						
                        .mb_0 {
                            margin-bottom: 0!important;
                        }

                    }
                
				}
                .c_right {
                    padding-bottom: 10px;
                    .f_img {
                        width: 96px;
                        height: 96px;
                        overflow: hidden;
                        .img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .f_intro {
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 22px;
                        color: #333333;
                    }
					
					.f_item {
					    .f_title {
					        font-size: 24px;
					        font-weight: bold;
					        line-height: 32px;
					        color: #333333;
					    }
					    .f_line {
					        width: 20px;
					        height: 1px;
					        background-color: #333;
					        margin-top: 24px;
					        margin-bottom: 24px;
					    }
					    .f_intro,
					    .f_intro_1,
					    .f_intro_2,
					    .f_intro_3,
					    .f_intro_4,
					    .f_intro_5,
						{
					        font-size: 14px;
					        font-weight: 400;
					        line-height: 22px;
					        color: #8C8C8C;
					        margin-bottom: 16px;
							img {
								width: 160px;
								height: 160px;
							}
					    }
						
						.f_intro_1 {
							&:hover {
								color: #262626;
								.code_1 {
									display: inline-block;
								}
							}
						}
						.f_intro_2 {
							&:hover {
								color: #262626;
								.code_2 {
									display: inline-block;
								}
							}
						}
						.f_intro_3 {
							&:hover {
								color: #262626;
								.code_3 {
									display: inline-block;
								}
							}
						}
						.f_intro_4 {
							&:hover {
								color: #262626;
								.code_3 {
									display: inline-block;
								}
							}
							.a_view {
								color: #8c8c8c;
								text-decoration: none;
								&:hover {
									color: #262626;
									.code_3 {
										text-decoration: underline!important;
									}
								}
							}
						}
						.f_intro_5 {
							&:hover {
								color: #262626;
								.code_3 {
									display: inline-block;
								}
							}
						}
						
					    .mb_0 {
					        margin-bottom: 0!important;
					    }
					
					}
					                


                }
            }
        }
		.h_code {
			height: 360px;
			// background-color: pink;
		}
        /* 回到顶部按钮 */
        .back_top {
            position: fixed;
            bottom: 268px;
            right: 80px;
            width: 42px;
            height: 42px;
            background: #8C8C8C;
            opacity: 1;
            border-radius: 2px;
            box-shadow: 0 0 4px 0 rgba(38, 38, 38, .4);
            z-index: 20;
            .icon {
                font-size: 20px;
                color:#fff;
            }
        }
    }
</style>
